import React from 'react';

const SvgExpired = (props: React.SVGProps<SVGSVGElement>) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 333 274" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M57.054 43.102s20.926 2.286 40.718 32.605c19.791 30.32 6.25 63.348 6.25 63.348s-31.394.165-46.824-38.217c-14.219-35.367-.144-57.736-.144-57.736z"
      fill="#EAF6F3"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M107.352 99.699l-12.203 19.378a1816.269 1816.269 0 00-9.995-21.478l10.197-25.451a94.235 94.235 0 00-.575-.808l-10.11 25.23c-4.633-9.77-9.09-18.926-13.099-26.907l2.89-18.83c-.257-.176-.512-.35-.765-.518L70.92 68.376C64.992 56.62 60.108 47.57 57.186 43.12l-.132-.017s-.153.244-.409.715c3.944 6.076 11.314 20.186 19.967 37.921l-25.69-8.41c.015.297.029.594.047.894l26.153 8.562a1648.037 1648.037 0 0112.065 25.366l-31.622-6.426c.129.31.257.625.388.93l31.672 6.438a1820.467 1820.467 0 019.981 21.842l-22.52-2.422c.431.338.862.663 1.293.98l21.623 2.324c1.08 2.409 2.149 4.813 3.21 7.211.526.029.81.028.81.028l.056-.14a1767.347 1767.347 0 00-8.514-18.93l12.003-19.06a79.296 79.296 0 00-.215-1.226z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.099 130.055s14.822-14.948 50.87-11.547c36.047 3.402 53.452 34.566 53.452 34.566s-19.425 24.664-59.063 12.83c-36.526-10.905-45.26-35.849-45.26-35.849z"
      fill="#EAF6F3"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M76.695 125.959l7.56 21.616a1809.94 1809.94 0 00-23.03-5.558l-13.56-23.831c-.331-.018-.662-.036-.99-.052l13.442 23.623c-10.53-2.46-20.469-4.676-29.209-6.51l-12.932-13.99a66.24 66.24 0 00-.882.276l12.404 13.418c-12.891-2.686-23.012-4.501-28.314-4.987l-.096.092s.096.273.305.766c7.21.699 22.839 3.721 42.103 7.998l-22.58 14.86c.241.174.483.348.729.521l22.987-15.128c8.568 1.91 17.825 4.061 27.36 6.36L47.27 166.17c.323.092.648.188.97.276l24.763-20.769c7.67 1.854 15.509 3.801 23.304 5.796l-15.921 16.111a51.973 51.973 0 001.572-.403l15.286-15.468c2.556.655 5.103 1.316 7.641 1.979.35-.392.527-.616.527-.616l-.076-.131a1746.38 1746.38 0 00-20.111-5.128l-7.436-21.263c-.362-.201-.725-.4-1.093-.595z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M332.299 149.487s-23.363-12.299-65.207 5.35c-41.844 17.648-50.927 61.489-50.927 61.489s32.529 22.187 75.492-6.902c39.59-26.805 40.642-59.937 40.642-59.937z"
      fill="#EAF6F3"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M240.304 173.065l-.901 28.709a2266.757 2266.757 0 0125.455-15.324l7.247-33.617c.389-.148.779-.294 1.165-.437l-7.183 33.325c11.671-6.91 22.727-13.304 32.492-18.792l10.201-21.608a74.84 74.84 0 011.16-.001l-9.785 20.724c14.41-8.068 25.834-14.052 31.995-16.632a9.4 9.4 0 01.149.075s-.012.362-.077 1.031c-8.362 3.552-25.921 13.056-47.357 25.429l32.611 9.271c-.222.298-.445.598-.675.898l-33.199-9.439a2056.311 2056.311 0 00-30.336 17.916l37.389 15.493c-.352.234-.706.471-1.055.697l-37.45-15.519a2276.759 2276.759 0 00-25.697 15.713l25.116 13.276a65.38 65.38 0 01-2.031.111l-24.116-12.747a2110.937 2110.937 0 00-8.395 5.246c-.568-.337-.862-.537-.862-.537l.041-.187a2186.585 2186.585 0 0122.128-13.711l.887-28.238c.356-.376.716-.751 1.083-1.125z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M316.876 255.123s-9.001-24.822-51.827-39.934C222.225 200.077 186 226.388 186 226.388s9.122 38.304 60.476 45.707c47.322 6.823 70.4-16.972 70.4-16.972z"
      fill="#EAF6F3"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M232.969 210.641l-19.989 20.625a2301.944 2301.944 0 0129.14 5.8l27.986-19.984c.388.153.775.306 1.157.461l-27.743 19.812c13.281 2.744 25.763 5.457 36.679 7.971l22.086-9.114c.292.26.579.52.86.779l-21.187 8.742c16.089 3.732 28.565 6.996 34.858 9.234l.06.156s-.252.259-.751.71c-8.574-3-27.958-7.791-52.139-13.067l17.877 28.806c-.366.07-.731.142-1.103.209l-18.2-29.327a2068.407 2068.407 0 00-34.494-7.167l17.224 36.625c-.417-.066-.84-.128-1.25-.197l-17.252-36.683a2307.355 2307.355 0 00-29.58-5.676l9.639 26.724a59.7 59.7 0 01-1.577-1.286l-9.256-25.658c-3.255-.599-6.502-1.189-9.74-1.77-.192-.631-.274-.978-.274-.978s.055-.041.154-.11a2246.37 2246.37 0 0125.596 4.752l19.66-20.286a79.45 79.45 0 011.559-.103zM268.87 4.686l2.87 4.383-5.081-.586-17.549-3.48 19.76-.317z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M271.74 9.069l-8.48.403 1.949-1.277 6.531.874z"
      fill="#fff"
    />
    <mask
      id="expired_svg__a"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={249}
      y={0}
      width={21}
      height={6}
    >
      <path d="M268.869 4.686L269.846 0l-20.737 5.003 19.76-.317z" fill="#fff" />
    </mask>
    <g mask="url(#expired_svg__a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M268.869 4.686L269.846 0l-20.737 5.003 19.76-.317z"
        fill="#F4F6F7"
      />
    </g>
    <mask
      id="expired_svg__b"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={249}
      y={5}
      width={18}
      height={11}
    >
      <path d="M249.109 5.004l17.549 3.48-1.811 6.798-15.738-10.278z" fill="#fff" />
    </mask>
    <g mask="url(#expired_svg__b)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M249.109 5.004l17.549 3.48-1.811 6.798-15.738-10.278z"
        fill="#F4F6F7"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M270.395 13.946a.399.399 0 00.008-.66 11.164 11.164 0 00-1.799-1.019.399.399 0 00-.326.727c.578.26 1.141.577 1.671.946a.4.4 0 00.446.006zm-9.239 11.62a5.705 5.705 0 00-3.687.058.398.398 0 11-.278-.747 6.432 6.432 0 014.217-.067.4.4 0 01.092.712.396.396 0 01-.344.044zm-6.126 5.254a.398.398 0 01-.512-.236c-.406-1.095-.413-2.2-.023-3.195.141-.36.334-.699.573-1.005a.399.399 0 01.63.49 3.22 3.22 0 00-.461.807c-.322.821-.313 1.705.028 2.627a.398.398 0 01-.235.512zm19.39-11.948a.4.4 0 01-.531-.191 12.747 12.747 0 00-.868-1.552c-.39-.596-.83-1.157-1.31-1.666a.397.397 0 01.018-.563.395.395 0 01.563.017c.511.543.981 1.14 1.397 1.775.343.524.653 1.079.921 1.65a.398.398 0 01-.19.53zm-8.464 10.513c-.996-1.228-1.879-2.102-2.778-2.75a.398.398 0 11.466-.647c.958.691 1.89 1.611 2.932 2.895a.399.399 0 11-.62.502zm-6.627 5.696a10.494 10.494 0 01-.99-.436 8.508 8.508 0 01-2.475-1.893.4.4 0 01.593-.533 7.702 7.702 0 002.241 1.714c.293.148.601.284.915.403a.398.398 0 01-.284.745zm16.121-9.916a.399.399 0 01-.373-.423 12.098 12.098 0 00-.388-3.862.399.399 0 01.771-.203c.36 1.37.5 2.754.413 4.116a.4.4 0 01-.423.372zm-9.561 10.404a12.444 12.444 0 01-4.138.13.4.4 0 11.11-.789c1.261.176 2.564.135 3.874-.123a.399.399 0 01.154.782zm7.113-4.548a.4.4 0 01-.07-.559c.498-.637.914-1.322 1.24-2.038.202-.446.375-.914.512-1.39a.4.4 0 01.766.22 11.08 11.08 0 01-.552 1.5 10.93 10.93 0 01-1.337 2.198.394.394 0 01-.559.07zm-2.764 3.679a.4.4 0 01-.55-.123 20.32 20.32 0 00-.181-.282c-.4.21-.813.399-1.234.568a.397.397 0 01-.517-.223.397.397 0 01.221-.518c.371-.148.736-.314 1.089-.497a61.978 61.978 0 00-1.65-2.337.4.4 0 01.083-.557.399.399 0 01.557.084 60.31 60.31 0 011.708 2.422 12.082 12.082 0 001.55-1.102.396.396 0 01.561.049c.143.168.12.42-.049.561-.505.424-1.05.813-1.623 1.158.054.082.105.164.158.246a.397.397 0 01-.117.547l-.006.004zm2.887 5.749a.398.398 0 01-.515-.228 29.03 29.03 0 00-1.696-3.59.397.397 0 11.696-.387 29.537 29.537 0 011.743 3.689.4.4 0 01-.228.516zm1.249 6.289a.4.4 0 01-.415-.383l-.008-.18a18.43 18.43 0 00-.604-3.702.4.4 0 01.771-.205c.346 1.296.557 2.596.629 3.863l.01.193a.4.4 0 01-.383.414zm-1.356 6.247a.398.398 0 01-.208-.524c.518-1.2.868-2.467 1.041-3.764a.399.399 0 11.789.105 15 15 0 01-1.099 3.975.397.397 0 01-.523.208zm-4.027 4.938a.399.399 0 01.081-.557c.997-.748 1.882-1.703 2.629-2.839a.4.4 0 01.666.438c-.798 1.213-1.746 2.236-2.818 3.039a.399.399 0 01-.558-.08zm-1.592 1.31a.398.398 0 00-.368-.703 8.553 8.553 0 01-1.828.519.398.398 0 10.129.785 9.341 9.341 0 002-.566.405.405 0 00.067-.036zm-157.043-37.59l-25.834-6.64-.328-1.6 26.162 8.24zm-26.572-2.209l.034.054 1.084 4.011 25.389-1.854-26.507-2.21zM20.74 68.269a19.3 19.3 0 002.486-1.08.376.376 0 01.346.668 20.09 20.09 0 01-3.54 1.432.373.373 0 01-.468-.251.375.375 0 01.251-.468c.31-.093.619-.194.925-.301zm50.562-53.982a66.81 66.81 0 013.728.59.376.376 0 01-.136.738 66.965 66.965 0 00-3.687-.584.378.378 0 01-.325-.42.375.375 0 01.42-.324zm-6.26.287a.376.376 0 01.22-.677c1.205-.01 2.478.04 3.785.15a.374.374 0 11-.063.748 40.593 40.593 0 00-3.715-.147.373.373 0 01-.227-.074zm-37.06 49.17a.37.37 0 01.53.007.374.374 0 01-.006.53 20.913 20.913 0 01-2.962 2.406.375.375 0 11-.418-.623 20.26 20.26 0 002.857-2.32zm1.548-1.1a.375.375 0 01-.052-.528 19.462 19.462 0 002.06-3.047.375.375 0 11.658.36 20.17 20.17 0 01-2.138 3.163.375.375 0 01-.528.053zm3.159-5.08a.375.375 0 01-.204-.49 25.58 25.58 0 001.142-3.514.375.375 0 01.727.183 26.156 26.156 0 01-1.175 3.616.375.375 0 01-.49.204zm9.952-32.026a29.052 29.052 0 00-2.165 3.005.376.376 0 01-.636-.399 29.343 29.343 0 012.22-3.082c.132-.16.357-.205.53-.052.16.131.182.367.05.527zM39.37 30.47a27.383 27.383 0 00-1.488 3.386.375.375 0 11-.706-.253c.424-1.18.938-2.352 1.528-3.481a.375.375 0 11.666.348zm7.462-9.117a30.516 30.516 0 00-2.717 2.52.375.375 0 11-.543-.518c.868-.91 1.806-1.78 2.783-2.582a.376.376 0 01.477.58zm6.92-4.271a.374.374 0 01-.495-.192.375.375 0 01.191-.495 29.698 29.698 0 013.565-1.312.376.376 0 01.214.72 28.85 28.85 0 00-3.475 1.279zM35.259 45.876a.375.375 0 01-.33-.415l.053-.473c.124-1.088.248-2.177.392-3.262a.376.376 0 01.744.099c-.143 1.08-.266 2.165-.39 3.248l-.054.472a.375.375 0 01-.415.33zm13.343-25.871a.375.375 0 11-.433-.613 31.185 31.185 0 013.23-1.996.376.376 0 01.354.662 30.305 30.305 0 00-3.151 1.947zm-13.52 27.363a.374.374 0 01.326.42 62.41 62.41 0 01-.569 3.733.376.376 0 01-.738-.14c.2-1.07.38-2.241.563-3.688a.376.376 0 01.419-.325zM17.667 69.099a.375.375 0 01.144.736 30.45 30.45 0 01-3.764.487.373.373 0 01-.401-.348.375.375 0 01.348-.401 29.843 29.843 0 003.673-.474zm19.29-33.583c.199.055.32.26.265.46a38.677 38.677 0 00-.774 3.634.375.375 0 11-.74-.124c.228-1.365.486-2.577.79-3.704.053-.2.258-.32.459-.266zM61.672 14.12a31.22 31.22 0 011.316-.128.376.376 0 01.057.749 26.932 26.932 0 00-3.665.517.374.374 0 01-.444-.29.375.375 0 01.29-.445 27.494 27.494 0 012.446-.403z"
      fill="#F4F6F7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M250.745 109.059l23.028-5.824 13.455 25.575-23.719 12.123-10.738-22.641-2.026-9.233z"
      fill="#F39400"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M291.732 152.447c16.079-10.042 22.017-30.908 13.159-48.045-8.857-17.137-29.315-24.36-46.806-17.052l33.647 65.097z"
      fill="#FFC543"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M134.161 78.805l-17.29-16.287-24.192 15.805 14.83 22.128 20.392-14.564 6.26-7.082z"
      fill="#F39400"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M77.248 96.787c-9.166-16.593-4.208-37.714 11.865-48.38 16.073-10.668 37.46-7.032 49.19 7.86l-61.055 40.52z"
      fill="#FFC543"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M247.757 97.573l-15.515-5.22c.016-.059 3.491-11.018-2.347-21.162-4.505-7.822-13.517-13.536-26.791-16.98-14.539-3.773-26.279-3.387-33.952 1.114-7.553 4.43-9.159 11.513-9.224 11.811l-16.057-3.207c.263-1.397 2.947-13.871 16.168-21.859 11.732-7.089 27.546-8.121 47.012-3.07 17.945 4.657 30.47 13.07 37.228 25.004 9.234 16.304 3.721 32.872 3.478 33.569z"
      fill="#32243F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M74.04 135.86c-15.232 55.473 17.39 112.792 72.864 128.025 55.475 15.232 112.795-17.391 128.027-72.866 15.232-55.474-17.391-112.793-72.866-128.025C146.591 47.762 89.272 80.384 74.04 135.86z"
      fill="#3F2D51"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M270.318 177.275l-.168-.468c-.304-.819-.62-1.635-.933-2.451a95.014 95.014 0 01-2.775 14.334c-13.816 50.314-65.99 80.009-116.305 66.193-28.971-7.954-51.102-28.627-62.03-54.339-.34.413-.71.795-1.095 1.16 11.185 25.837 33.539 46.576 62.737 54.594 51.095 14.03 104.078-16.125 118.108-67.22a96.687 96.687 0 002.461-11.803zM130.161 80.462c20.72-11.224 45.623-14.796 70.087-8.078a95.289 95.289 0 019.355 3.098c.176-.459.37-.908.585-1.346a96.679 96.679 0 00-9.551-3.167c-24.492-6.724-49.413-3.293-70.273 7.725a14.081 14.081 0 01-.203 1.768z"
      fill="#fff"
    />
    <mask
      id="expired_svg__c"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={88}
      y={77}
      width={174}
      height={174}
    >
      <path
        d="M91.724 140.713c-12.657 46.099 14.452 93.73 60.55 106.388 46.098 12.658 93.73-14.451 106.387-60.55 12.659-46.098-14.45-93.73-60.549-106.387-46.099-12.658-93.73 14.451-106.388 60.549z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#expired_svg__c)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M91.724 140.713c-12.657 46.099 14.452 93.73 60.55 106.388 46.098 12.658 93.73-14.451 106.387-60.55 12.659-46.098-14.45-93.73-60.549-106.387-46.099-12.658-93.73 14.451-106.388 60.549z"
        fill="#FFFBDC"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M193.555 100.912l-2.122-.582 5.034-18.334 2.123.583-5.035 18.333zm-39.557 144.066l-2.122-.583 5.033-18.334 2.123.584-5.034 18.333zm83.809-63.168l.583-2.123 18.333 5.035-.582 2.122-18.334-5.034zM93.742 142.252l.582-2.123 18.334 5.035-.582 2.122-18.334-5.034zm115.821 83.019l1.259-.717 6.189 10.875-1.258.717-6.19-10.875zM132.952 90.663l1.259-.717 6.19 10.875-1.259.717-6.19-10.875zm104.254 37.802l-.716-1.259 10.875-6.19.717 1.258-10.876 6.191zm-134.607 76.61l-.717-1.259 10.875-6.189.717 1.259-10.875 6.189zm142.756-52.774l-.234-1.43 12.351-2.014.232 1.429-12.349 2.015zM92.492 177.235l-.233-1.43 12.35-2.014.233 1.429-12.35 2.015zm127.06-69.698l-1.139-.896 7.735-9.837 1.139.897-7.735 9.836zm-95.736 121.749l-1.14-.895 7.735-9.836 1.139.895-7.734 9.836zm42.113-136.85l-1.435.199-1.717-12.395 1.434-.199 1.718 12.394zm21.258 153.415l-1.435.2-1.717-12.395 1.434-.199 1.718 12.394zM119.46 118.493l-.895 1.137-9.839-7.731.895-1.139 9.839 7.733zm121.778 95.699l-.895 1.139-9.839-7.732.895-1.139 9.839 7.732z"
      fill="#32243F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M175.815 167.139c1.339-23.996 8.127-43.033 12.219-52.551.774-1.797 3.446-1.288 3.511.668.231 7.106-.521 17.568-1.4 24.007-2.161 15.83-13.195 31.096-14.33 27.876z"
      fill="#3F2D51"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M177.377 169.044c-21.295 11.141-41.122 15.062-51.393 16.422-1.939.258-2.871-2.3-1.225-3.356 5.985-3.84 15.357-8.552 21.336-11.094 14.703-6.254 33.465-4.597 31.282-1.972z"
      fill="#3F2D51"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M169.205 160.45a7.521 7.521 0 005.261 9.246 7.523 7.523 0 10-5.261-9.246z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M173.293 161.573a3.283 3.283 0 106.333 1.736 3.283 3.283 0 00-6.333-1.736z"
      fill="#32243F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.238 176.212l.776 6.62-7.102.391 1.266-10.302 5.06 3.291z"
      fill="#FDBF86"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.44 177.391c.825-.036 1.588-.171 1.983-.503 2.328-3.499-.527-12.792-.527-12.792l-3.83-1.544-4.79 3.09-.179 6.259c-.048 1.671.779 3.262 2.226 4.282 1.544.837 3.32 1.286 5.117 1.208z"
      fill="#FDBF86"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.093 169.175c.25-1.054.074-3.477 1.146-3.318.783.116 3.459.185 4.359.171 2.145-.033 5.955-.932 5.905-4.194-.025-1.632-1.629-3.015-2.638-3.418-.99-.396-2.1-.359-3.102.008-2.35.862-5.454 2.731-6.707 2.5-2.108-.391-4.186.874-4.129 2.658.061 1.908 1.1 4.762 2.066 6.57a10.009 10.009 0 002.185 2.769l.915-3.746z"
      fill="#4C4C4C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.922 169.444c.471-.429 1.367-.363 2.001.148.634.511.765 1.274.293 1.703-.471.43-1.367.363-2-.148-.634-.511-.766-1.274-.294-1.703z"
      fill="#FDBF86"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M71.042 206.562s2.912-2.205 5.509-7.947c.571-1.263.373-2.77 2.557-2.383l-1.292 7.296-2.123 5.883 1.049.187-.58 3.277s-5.522-.036-5.871-2.072l.75-4.241z"
      fill="#32243F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M67.077 206.524l3.965.037a3.768 3.768 0 01-.577 4.041l-.174.2-3.793-1.008.58-3.27z"
      fill="#F7B58E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M57.253 262.581l-1.327 3.417a3.518 3.518 0 01-3.687-.967l-.168-.183 1.043-3.499 4.139 1.232z"
      fill="#FEBE88"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46.473 217.351s.623-4.595-3.35-14.595c9.78 8.02 24.917 8.649 24.917 8.649l.916-5.171-31.088-18.63-6.982 30.214 15.38 2.722.207-3.189z"
      fill="#32243F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.067 179.5s-19.296 12.991-4.02 48.238l18.542-10.664-2.658-17.425 5.653-11.853-17.517-8.296z"
      fill="#FFC543"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.046 227.737s5.02 9.64 13.227 11.64c8.209 2.001 25.22-3.74 25.22-3.74s-9.63 8.093-8.131 26.158c4.361 1.89 5.3 2.056 5.3 2.056s19.373-33.488 13.855-39.935c-5.518-6.447-30.928-6.843-30.928-6.843l-18.543 10.664zm33.955 37.841s.355 2.818 8.238 4.844c1.617.416 1.116.908 1.442 1.569-2.558.099-7.907.536-7.907.536l-4.914-2.937-1.055.981-2.629-2.389s1.043-3.647 2.97-3.753c1.61.481 3.855 1.149 3.855 1.149z"
      fill="#3F2D51"
    />
    <path
      d="M191.344 126.099L52.071 200.424s-4.879 16.903 16.21 22.812c6.022 1.688 10.758 6.407 12.248 12.481 6.36 25.924-47.515 32.763-47.515 32.763"
      stroke="#F39400"
      strokeWidth={2}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.931 199.648s13.929 1.645 21.027.167c7.099-1.479 21.574-12.186 21.574-12.186l-3.66-2.5-17.207 6.061-16.08-3.395-5.654 11.853z"
      fill="#FDBF86"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M77.077 185.194c.382-.007 1.693-.15 3.906-1.677 1.984-1.37 5.278-5.427 6.03-2.971-.992 2.421-1.866 5.382-1.866 5.382-.743 1.405-3.157 2.56-4.797 2.995l-5.204.728s-1.897-1.704-2-1.769l.528-.974a12.349 12.349 0 003.403-1.714z"
      fill="#FDBF86"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M78.384 185.489s.135.04.389.053c-.166.303-.312.609-.447.919-.952.825-1.878 1.679-2.82 2.513-.4-.61-.965-1.465-1.016-1.519l5.087-6.692s1.058.245.49 1.911a8.367 8.367 0 01-1.683 2.815z"
      fill="#FDBF86"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M277.022 146.058l-.292-.108.003.155.191.103.098-.15z"
      fill="#F49B42"
    />
  </svg>
);

export default SvgExpired;
